const STATUS = {
  presente: { bg: "#E8F5E9", text: "#1B5E20", border: "#A5D6A7", label: "Presente" },
  assente_temporaneo: { bg: "#FFF3E0", text: "#E65100", border: "#FFE0B2", label: "Temporaneamente assente" },
  archiviato: { bg: "#ECEFF1", text: "#37474F", border: "#CFD8DC", label: "Archiviato" },
  scaduto: { bg: "#FFEBEE", text: "#C62828", border: "#FFCDD2", label: "Scaduta" },
  in_scadenza: { bg: "#FFF8E1", text: "#F57F17", border: "#FFE082", label: "In scadenza" },
  futuro: { bg: "#E8F5E9", text: "#2E7D32", border: "#C8E6C9", label: "Futura" },
  completato: { bg: "#ECEFF1", text: "#455A64", border: "#CFD8DC", label: "Completata" },
  uscito_trasferito: { bg: "#ECEFF1", text: "#37474F", border: "#CFD8DC", label: "Trasferimento" },
  venduto: { bg: "#E3F2FD", text: "#0D47A1", border: "#BBDEFB", label: "Vendita" },
  deceduto: { bg: "#EFEBE9", text: "#4E342E", border: "#D7CCC8", label: "Decesso" },
  altro: { bg: "#F3E5F5", text: "#6A1B9A", border: "#E1BEE7", label: "Altro" },
};

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS[status] || STATUS.altro;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${className}`}
      style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
    >
      {s.label}
    </span>
  );
}

export { STATUS };
